import React from 'react';
import Dots from 'react-native-dots-pagination';
import styles from './styles';
import {View} from 'react-native';
import {useTheme} from '../../../theme';

export default function BreadCrumbs({
  current = 1,
  total = 0,
  activeColor,
  currentPassiveColor,
  passiveColor,
  activeDotWidth = 14,
  activeDotHeight = 7,
  currentPassiveDotWidth = 7,
  currentPassiveDotHeight = 7,
  passiveDotWidth = 7,
  passiveDotHeight = 7,
  containerStyle = {},
  rightDotStyle = {},
}) {
  // Themed DEFAULTS only (legacy orange → warning, grey3 → textDisabled;
  // identical in light). Explicit color props still win.
  const {colors} = useTheme();
  const resolvedActiveColor =
    activeColor === undefined ? colors.warning : activeColor;
  const resolvedCurrentPassiveColor =
    currentPassiveColor === undefined ? colors.warning : currentPassiveColor;
  const resolvedPassiveColor =
    passiveColor === undefined ? colors.textDisabled : passiveColor;
  return (
    <View style={[styles.breadCrumbContainerStyle, containerStyle]}>
      <Dots
        length={current}
        active={current - 1}
        paddingHorizontal={0}
        marginHorizontal={4}
        activeDotWidth={activeDotWidth}
        activeDotHeight={activeDotHeight}
        passiveDotHeight={currentPassiveDotWidth}
        passiveDotWidth={currentPassiveDotHeight}
        activeColor={resolvedActiveColor}
        passiveColor={resolvedCurrentPassiveColor}
      />
      <View style={[styles.rightDotStyle, rightDotStyle]}>
        <Dots
          length={total - current}
          paddingHorizontal={0}
          marginHorizontal={4}
          passiveDotHeight={passiveDotWidth}
          passiveDotWidth={passiveDotHeight}
          passiveColor={resolvedPassiveColor}
        />
      </View>
    </View>
  );
}
